import React from "react";
import { StyleSheet, View, ViewStyle } from "react-native";
import { theme } from "ui-components";
import { CircularProgress } from "./circular-progress";

export interface LoaderIndicatorProps {
  loading?: boolean;
  containerStyle?: ViewStyle;
  accessibilityLabel?: string;
  strokeColor?: string;
  size?: number;
  testID?: string;
  backgroundStrokeColor?: string;
  strokeWidth?: number;
}
export const LoaderIndicator = (props: LoaderIndicatorProps) => {
  let {
    accessibilityLabel,
    strokeColor = theme.colors.primary,
    loading,
    size = 60,
    testID,
    containerStyle,
    backgroundStrokeColor,
    strokeWidth = 6,
  } = props;

  return (
    <View
      style={[styles.container, containerStyle]}
      testID={testID + "-loader-indicator"}
      accessibilityLabel=" loader indicator">
      <CircularProgress
        backgroundStrokeColor={backgroundStrokeColor}
        size={size}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
        accessibilityLabel={accessibilityLabel}
        testID={testID}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
  },
});
